WB.Utility = WB.Utility || {};

WB.Utility.LocationUtility = function() {

    var _this = this;

    this.GetCoordinateAsKey = function (coordinate) {
        var unitId = coordinate.Units ? coordinate.Units : 1;
        return parseFloat(coordinate.Latitude).toFixed(7) + ',' + parseFloat(coordinate.Longitude).toFixed(7) + ',' + unitId;
    };

    this.GetLocationAsKey = function(location) {
        if(!location) return '';
        var stationId = location.Station ? location.Station.StationId : '',
            providerId = location.Station ? location.Station.ProviderId : '',
            unitId = location.Units ? location.Units : 1;
        return this.GetCoordinateAsKey(location.Locality) + ':' + stationId + ',' + providerId + ',' + unitId;
    };

    this.$get = function() {
        return _this;
    };

};
WB.Core.provider('LocationUtility', WB.Utility.LocationUtility);
